import * as React from 'react';
import { ButtonTertiary, SingleValueComponent, ButtonPrimary, Validation } from 'ui/common';
import { DisplayDate, DisplayText } from 'ui';
import styles from './toggle-button.scss';

export interface ToggleButtonProps extends SingleValueComponent<Date | string | number>{
  textLabel: string;
  textLabelToggle: string;
  valueResolver: () => Date | string | number;
}

export const ToggleButton: React.SFC<ToggleButtonProps> = props => {

  const {
    value,
    valueResolver,
    readOnly,
    textLabel,
    textLabelToggle,
    componentId,
    className,
    onChange,
    validation
  } = props;

  const buttonText = value ? textLabelToggle : textLabel;

  const handleChange = () => {
    onChange && valueResolver &&
      onChange( value === undefined ?  valueResolver() : undefined );
  };

  const ValueComponent:any = (value instanceof Date) ? DisplayDate : DisplayText;
  const ButtonComponent:any = value ? ButtonTertiary : ButtonPrimary;
  const signedStyles = value ? styles.signed : '';  
  const hasValidationErrors = (validation && !!validation.messages.length);
  const validationErrorStyle = hasValidationErrors && styles.validationError;  

  return (
    <div className={`form-group ${className}`} id={componentId}>
      <div className={`${styles.toggleWrapper} ${signedStyles} ${validationErrorStyle}`}>
        <ValueComponent {...props} componentId={`${componentId}_value`} className="has-bg-color" value={value} showStacked={true}/>
        <ButtonComponent
          componentId={`${componentId}_button`}
          className={className}
          disabled={readOnly}
          onClick={handleChange}
          >{buttonText}
        </ButtonComponent>        
      </div>
      {hasValidationErrors && <Validation {...validation}/>}       
    </div>);
};
